import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { ComponentDefinition } from '@models/index';
import { IStateIcon } from '../../../components';

class DynamicWidgetsNavigationController implements angular.IComponentController {
    routes: IStateIcon[] = [];

    static $inject = ['$state'];
    constructor(private _$state: StateService) {
    }

    $onInit() {
        const visibleStates = ['trends', 'tables'];
        this.routes = this._$state.get()
            .filter(s => visibleStates.indexOf(s.name) >= 0)
            .sort((a, b) => a.data.sortingOrder - b.data.sortingOrder)
            .map(s => {
                return {
                    sref: s.name,
                    icon: s.data.icon,
                    tooltip: s.data.displayName,
                    order: s.data.sortingOrder
                };
            });
    }
}

export const wtDynamicWidgetsNavigation: ComponentDefinition = {
    componentId: 'wtDynamicWidgetsNavigation',
    controller: DynamicWidgetsNavigationController,
    template: require('./dynamicWidgetsNavigation.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
